import clsx from 'clsx'
import { rem } from 'polished'
import { useContext } from 'react'
import * as React from 'react'
import styled from 'styled-components'

import TripContext from 'tripPlanner/contexts/TripContext'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Root = styled.div`
  padding-bottom: ${rem(8)};

  &.noBottomPadding {
    padding-bottom: 0;
  }
`

const Box = styled.div`
  background: transparent;

  &.dragEnabled {
    ${mediaQueryUp.tablet} {
      padding-right: ${rem(8)};
    }
  }
`

interface Props {
  className?: string
  noBottomPadding?: boolean
}

/** Provide right-padding that makes the item card align with one that's in a DraggableItemWrapper */
function NonDraggableItemWrapper({
  children,
  className,
  noBottomPadding,
}: React.PropsWithChildren<Props>) {
  const {
    permissions: { canEdit },
  } = useContext(TripContext)!

  return (
    <Root className={clsx(className, { noBottomPadding })}>
      <Box className={clsx({ dragEnabled: canEdit })}>{children}</Box>
    </Root>
  )
}

export default NonDraggableItemWrapper
